<ng-container *transloco="let t">
@if (applicationTasks.length > 0) {
  <table class="table bp-table fixTableHead">
    <thead>
      <tr>
        <th class="min-w-200px">{{ t('portal.tasks.task') }}</th>
        <th class="min-w-130px">{{ t('portal.tasks.dueDateHeader') }}</th>
        <th class="min-w-200px">{{ t('portal.tasks.status') }}</th>
        <th class="min-w-50px">{{ t('portal.tasks.actions') }}</th>
      </tr>
    </thead>
    <tbody>
      @for (task of applicationTasks; track task.taskId) {
        <tr class="bp-table-row">
          <td class="min-w-200px">
            <span class="fw-bold">{{ (task | taskText:'docType') || (task | taskText:'description') }}</span>
          </td>
          <td class="min-w-130px">
            <span class="fw-bold">{{ task.dueDate | dateAgo }}</span>
          </td>
          <td class="min-w-200px">
            <span class="fw-bold">{{ task.borrowerTaskStatus }}</span>
          </td>
          <td>
            <div>
              @if (task.templateDocumentUrl) {
                <a
                  [title]="t('portal.tasks.viewTemplateDoc')"
                  class="align-text-bottom"
                  (click)="goToLink(task.templateDocumentUrl)"
                >
                  <i class="far fa-eye"></i>
                </a>
              }

              <a
                [title]="t('portal.tasks.addFiles')"
                class="mx-2 align-text-bottom"
                (click)="openAddFiles(task)"
              >
                <i class="fas fa-upload"></i>
              </a>

              <a
                [title]="t('portal.tasks.attachedDocuments')"
                class="mx-2 align-text-bottom"
                (click)="openAttachedDocuments(task)"
              >
                <i class="far fa-paperclip"></i>
              </a>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
}

@if (applicationTasks.length === 0) {
  <h2 class="text-center my-4">
    {{ t('portal.tasks.noTaskFound') }}
  </h2>
}
</ng-container>
